import React from "react";
import SecondBlue from "../icons/second-blue.png";
import Second from "../icons/second.png";

const ContactDetailStepIcon = ({ show, completed }) => {
  let iconSrc;

  if (completed || show) {
    iconSrc = Second;
  } else {
    iconSrc = SecondBlue;
  }

  return (
    <div className="WH32">
      <img src={iconSrc} alt="Step Icon" />
    </div>
  );
};

export default ContactDetailStepIcon;
